import Vue from "vue";

const getDefaultState = () => ({
  mode: null,
  cpvId: null,
  chat: {
    id: null,
    messages: []
  },
  activeOptions: [],
  specification: null,
  search: {
    status: null,
    startAt: null,
    chatId: null,
    results: [],
    message: null,
  },
})

const state = {
    activeId: null,
    states: {},
}

const getters = {
  getActiveId: state => state.activeId,
  getMode: state => state.states[state.activeId]?.mode,
  getCpvId: state => state.states[state.activeId]?.cpvId,
  getChatId: state => state.states[state.activeId]?.chat.id,
  getChatMessages: state => state.states[state.activeId]?.chat?.messages,
  getSpecification: state => state.states[state.activeId]?.specification,
  getActiveOptions: state => state.states[state.activeId]?.activeOptions,
  getSearchStartAt: state => state.states[state.activeId]?.search?.startAt,
  getSearchChatId: state => state.states[state.activeId]?.search?.chatId,
  getSearchStatus: state => state.states[state.activeId]?.search?.status,
  getSearchResults: state => state.states[state.activeId]?.search?.results,
  getSearchMessage: state => state.states[state.activeId]?.search?.message,
}

// const actions = {}

const actions = {
  async startChat({ state, commit }, payload) {

    if (state.states[state.activeId].mode === 'custom_normalize') {
      return;
    }

    let action = 'chat/start';
    if (state.states[state.activeId].mode === 'cpv') {
      action = 'chat/get-ready-specs'
    }

    try {
      // eslint-disable-next-line no-undef
      const response = await $client2.post(action, {
        type: 'cpv',
        value: payload.cpvId
      });

      if (!response.data.status) {
        return false;
      }

      commit('setChatId', response.data.data.chat_id)

      if (state.states[state.activeId].mode === 'qa') {
        commit('addMessage', {
          role: 'Bot',
          content: response.data.data.first_question.question,
        })

        commit('setActiveOptions', response.data.data.first_question.options.map(option => ({
          id: option,
          content: option
        })))
      } else {
        commit('setActiveOptions', response.data.data.specifications.map(option => ({
          id: option.specefication,
          content: option.specification,
          content_ru: option.specification_ru
        })))
      }

      if (response.data?.data?.min_price) {
        commit('setSpecification', {
          price_info: {
            min: response.data.data.min_price,
            max: response.data.data.max_price
          }
        })
      }

      return response;
    } catch (error) {

      console.error('Error fetching chat:', error);
      return false;
    }
  },
  async chatMsg({ state, commit }, payload) {
    try {
      // request
      // eslint-disable-next-line no-undef
      const response = await $client2.post('chat/msg', {
        type: payload.type,
        value: payload.value,
        chat_id: state.states[state.activeId].chat.id
      });

      if (!response.data.status) {
        return false;
      }

      // handle message
      if (response.data.data.type === 'result') {

        commit('setSpecification', {
          main: response.data.data.specification,
          ru: response.data.data.specification_ru,
          price_info: {
            min: response.data.data.min_price,
            max: response.data.data.max_price
          }
        })

        commit('addMessage', {
          role: 'Bot',
          content: response.data.data.specification,
        })

        commit('setActiveOptions', [])

      } else {
        commit('addMessage', {
          role: 'Bot',
          content: response.data.data.question,
        })
      }

      if (response.data.data.type !== 'result') {
        commit('setActiveOptions', response.data.data.options.map(option => ({
          id: option,
          content: option
        })))
      }

      return response;
    } catch (error) {
      return false;
    }
  },
  async normalizeSpecification({ state, commit }, payload) {

    try {
      // eslint-disable-next-line no-undef
      const response = await $client2.post('chat/normalize-specification', {
        cpv_id: payload.cpvId,
        user_specification: payload.user_specification
      });

      if (!response.data.status) {
        return false;
      }

      await commit('setSpecification', {
        main: response.data.data.first_question.specification,
        ru: response.data.data.first_question.specification_ru,
        price_info: {
          min: response.data.data.min_price,
          max: response.data.data.max_price
        }
      })

      commit('addMessage', {
        role: 'Bot',
        content: response.data.data.first_question.specification,
      })

      return response;
    } catch (error) {

      return false;
    }
  },
  async search({ commit }, payload) {

    try {
      // eslint-disable-next-line no-undef
      const response = await $client2.post('chat/search', payload);

      if (!response.data.status) {
        return false;
      }

      await commit('setSearchStatus', 1)
      await commit('setSearchStartAt', Date.now())
      await commit('setSearchChatId', response.data.data.chat_id)

    } catch (error) {
      return false;
    }
  },
  async searchResult({ state, commit }){
    try {
      // eslint-disable-next-line no-undef
      const response = await $client2.post('chat/search-result', { chat_id: state.states[state.activeId].search.chatId});

      if (!response.data.status) {
        return false;
      }

      const status = Number(response.data.data.state) || 0;

      if (status === 2) {
        await commit('setSearchResults', response.data.data.results)
      }
      if (status === 2 || status === 3) {
        await commit('setSearchStatus', status);
      }

      await commit('setSearchMessage', response.data?.data?.message ?? null);

      return true
    } catch (error) {
      return false;
    }
  }
}

const mutations = {
  setMode(state, mode) {
    state.states[state.activeId].mode = mode
  },
  setCpvId(state, payload) {
    state.states[state.activeId].cpvId = payload
  },
  setChatId(state, payload) {
    state.states[state.activeId].chat.id = payload
  },
  addMessage(state, payload) {
    state.states[state.activeId].chat.messages.push(payload)
  },
  setSpecification(state, payload) {
    state.states[state.activeId].specification = payload
  },
  setActiveOptions(state, payload) {
    state.states[state.activeId].activeOptions = payload
  },
  setActiveOptionSelected(state, idx) {
    if (!state.states[state.activeId].activeOptions[idx]?.selected) {
      state.states[state.activeId].search.status = null
    }

    state.states[state.activeId].activeOptions = state.states[state.activeId].activeOptions.map((opt, i) => ({
      ...opt,
      selected: i === idx
    }))
  },
  setSearchStartAt(state, payload) {
    state.states[state.activeId].search.startAt = payload
  },
  setSearchResults(state, payload) {
    state.states[state.activeId].search.results = payload
  },
  setSearchChatId(state, payload) {
    state.states[state.activeId].search.chatId = payload
  },
  setSearchStatus(state, payload) {
    state.states[state.activeId].search.status = payload
  },
  setSearchMessage(state, message) {
    state.states[state.activeId].search.message = message
  },
  setActiveState(state, payload) {
    state.activeId = payload
    Vue.set(state, 'activeId', payload);
    if (!Object.hasOwn(state.states, payload)) {
        Vue.set(state.states, payload, getDefaultState());
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
